import { render, staticRenderFns } from "./temp.vue?vue&type=template&id=5c6fe2ff&scoped=true"
import script from "./temp.vue?vue&type=script&lang=js"
export * from "./temp.vue?vue&type=script&lang=js"
import style0 from "./temp.vue?vue&type=style&index=0&id=5c6fe2ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6fe2ff",
  null
  
)

export default component.exports